import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M16.5 0C17.1627 6.76691e-08 17.7 0.537258 17.7 1.2V6.3H22.8C23.4627 6.3 24 6.83726 24 7.5V16.5C24 17.1627 23.4627 17.7 22.8 17.7H17.7V22.8C17.7 23.4627 17.1627 24 16.5 24H7.5C6.83726 24 6.3 23.4627 6.3 22.8V17.7H1.2C0.537259 17.7 4.832e-09 17.1627 0 16.5V7.5C9.66384e-08 6.83726 0.537258 6.3 1.2 6.3H6.3V1.2C6.3 0.537259 6.83726 3.38013e-08 7.5 0H16.5Z",
		fill: "#FA8C16"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M16.5%200C17.1627%206.76691e-08%2017.7%200.537258%2017.7%201.2V6.3H22.8C23.4627%206.3%2024%206.83726%2024%207.5V16.5C24%2017.1627%2023.4627%2017.7%2022.8%2017.7H17.7V22.8C17.7%2023.4627%2017.1627%2024%2016.5%2024H7.5C6.83726%2024%206.3%2023.4627%206.3%2022.8V17.7H1.2C0.537259%2017.7%204.832e-09%2017.1627%200%2016.5V7.5C9.66384e-08%206.83726%200.537258%206.3%201.2%206.3H6.3V1.2C6.3%200.537259%206.83726%203.38013e-08%207.5%200H16.5Z%22%20fill%3D%22%23FA8C16%22%2F%3E%0A%3C%2Fsvg%3E%0A";
